export default "__VITE_ASSET__BdoxIbzL__"